<template>
	<div class="generated-poster-page">
		<!-- 导航栏（复用原有） -->
		<div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
			<div class="back-btn" @click="onBack">
				<img src="@/assets/back.svg" class="back-icon" />
			</div>
			<div class="nav-title">生成海报</div>
		</div>

		<!-- 主体轮播区域（纯原生实现） -->
		<div class="page-body">
			<!-- 轮播容器：核心滑动区域 -->
			<div class="carousel-container" ref="carouselContainer" @touchstart="handleTouchStart"
				@touchmove="handleTouchMove" @touchend="handleTouchEnd" @mousedown="handleTouchStart"
				@mousemove="handleTouchMove" @mouseup="handleTouchEnd" @mouseleave="handleTouchEnd">
				<!-- 轮播轨道：平移实现滑动 -->
				<div class="carousel-track" ref="carouselTrack"
					:style="{ transform: `translateX(${translateX}px)`, transition: transitionStyle }">
					<!-- 轮播项：外层固定宽高容器 -->
					<div class="carousel-item-container" v-for="(url, index) in posterUrls" :key="index">
						<!-- 图片容器：内部缩放，控制40px间距 -->
						<div class="carousel-item" :class="{ active: currentIndex === index }">
							<div class="poster-card">
								<img class="poster-img" :src="url" @click="onPreviewPoster(url)" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 自定义指示器（圆点） -->
			<div class="indicator-wrapper">
				<span class="indicator-dot" :class="{ active: currentIndex === index }"
					v-for="(item, index) in posterUrls" :key="index" @click="jumpToIndex(index)"></span>
			</div>

			<!-- 底部操作按钮 -->
			<div class="preview-actions">
				<div class="download-btn" @click="onDownload">下载</div>
				<div class="share-btn" @click="handleShare">分享</div>
			</div>
		</div>
		<div class="vip-tip-mask" v-if="showVipTipModal" @click="closeVipTipModal"></div>
		<div class="vip-tip-modal" v-if="showVipTipModal">
			<div class="vip-tip-title">提示</div>
			<div class="vip-tip-content">下载与转发属于订阅付费功能，付费后可正常使用下载与转发</div>
			<div class="vip-tip-btn-group">
				<button class="vip-tip-btn cancel-btn" @click="closeVipTipModal">返回</button>
				<button class="vip-tip-btn pay-btn" @click="goToPay">去付费</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		deviceEnv
	} from '@/utils/device.js';
	import {
		checkVip
	} from "@/api/poster";
	export default {
		name: 'GeneratedPosterPage',
		data() {
			return {
				vipType: '',
				showVipTipModal: false,
				// 写死4张测试图
				posterUrls: [],
				currentIndex: 0, // 当前选中索引
				translateX: 0, // 轨道平移距离
				startX: 0, // 触摸起始X坐标
				startTranslateX: 0, // 触摸起始时的平移距离
				isDragging: false, // 是否正在拖拽
				transitionStyle: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)', // 过渡动画
				isMiniProgram: false, //小程序环境
				currentPlatform: '',
			};
		},
		mounted() {
			this.getVip()
			this.isMiniProgram = deviceEnv.isWechatMiniProgram;
			document.title = "生成海报";
			this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
			const posterUrls = this.$route.query.posterUrls || [];
			// 若传的是JSON字符串，需解析（上一页传值时需 JSON.stringify）
			this.posterUrls = Array.isArray(posterUrls) ? posterUrls : JSON.parse(posterUrls);
			// 初始化计算轮播位置
			this.calcCarouselPosition();
			// 窗口大小变化时重新计算
			window.addEventListener('resize', this.calcCarouselPosition);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.calcCarouselPosition);
		},
		methods: {
			async getVip() {
				try {
					const data = await checkVip({});
					console.log("数据", data);
					this.vipType = data.vip
				} catch (error) {
					console.error("获取失败：", error);
				}
			},
			closeVipTipModal() {
				this.showVipTipModal = false;
			},
			goToPay() {
				this.showVipTipModal = false;
				// 此处对接付费页面/逻辑
				this.$toast('跳转至付费页面...');
				// 示例：window.location.href = '/pages/vip/pay';
			},
			async handleShare() {
				console.log("111111",this.vipType)
				// if (String(this.vipType) !== '1') {
				// 	this.showVipTipModal = true;
				// 	return;
				// }
				// 1. 基础校验：获取当前居中的图片URL
				const currentImageUrl = this.posterUrls[this.currentIndex];
				if (!currentImageUrl) {
					this.$toast('当前图片链接为空，无法转发');
					return;
				}

				// 2. 校验微信小程序环境
				if (this.isMiniProgram) {
					// 校验wx对象是否存在（小程序webview需提前注入）
					if (typeof wx === 'undefined' || !wx.miniProgram) {
						console.error('微信小程序webview未注入wx对象');
						this.$toast('转发功能暂不可用，请刷新页面重试');
						return;
					}

					try {
						// 分享参数（适配纯图片URL）
						const shareParams = {
							title: '精美海报', // 自定义分享标题
							path: `/pages/image/view?url=${encodeURIComponent(currentImageUrl)}`, // 小程序图片预览页路径
							imageUrl: currentImageUrl // 直接使用当前图片作为分享图
						};

						// 方案1：向小程序发送分享指令（小程序端需监听message事件）
						wx.miniProgram.postMessage({
							data: {
								type: 'shareImage',
								...shareParams
							}
						});

						// 方案2：跳转小程序图片预览页（实时触发分享，体验更好）
						wx.miniProgram.navigateTo({
							url: `/pages/image/view?url=${encodeURIComponent(currentImageUrl)}&isShare=1`
						});

						this.$toast('已唤起分享功能，请在小程序中确认');
					} catch (err) {
						console.error('调用小程序转发失败：', err);
						this.$toast('转发功能暂不可用，请稍后重试');
					}
				} else {
					// 非小程序环境：区分微信浏览器/其他浏览器
					const tip = deviceEnv.isWechatBrowser() ?
						'请在对应小程序中打开以使用转发功能' :
						'转发功能仅支持微信小程序环境';
					this.$toast(tip);
				}
			},
			// 返回上一页
			onBack() {
				this.$router.back();
			},

			// 计算轮播初始位置（固定宽高容器居中）
			calcCarouselPosition() {
				// 初始化位置：强制居中显示第一个
				this.centerToIndex(0);
			},

			// 居中到指定索引（核心：固定容器宽度计算，无gap）
			centerToIndex(index) {
				this.currentIndex = index;
				this.transitionStyle = 'none';
				// 核心公式：屏幕宽度/2 - 固定项宽度/2 - 索引*固定项宽度
				const screenWidth = document.documentElement.clientWidth;
				const itemWidth = (64 / 100) * screenWidth; // 64vw转px
				this.translateX = (screenWidth / 2 - itemWidth / 2) - index * itemWidth;
				// 强制重绘后恢复动画
				this.$nextTick(() => {
					this.transitionStyle = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
				});
			},

			// 点击圆点跳转到指定索引
			jumpToIndex(index) {
				if (index === this.currentIndex) return;
				this.centerToIndex(index);
			},

			// 触摸/鼠标按下事件
			handleTouchStart(e) {
				this.isDragging = true;
				this.startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
				this.startTranslateX = this.translateX;
				this.transitionStyle = 'none'; // 拖拽时取消动画
			},

			// 触摸/鼠标移动事件
			handleTouchMove(e) {
				if (!this.isDragging) return;
				const currentX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
				const diffX = currentX - this.startX;
				// 计算新的平移距离（无gap）
				this.translateX = this.startTranslateX + diffX;

				// 边界限制：拖拽时的弹性效果（适配固定宽高容器）
				const screenWidth = document.documentElement.clientWidth;
				const itemWidth = (64 / 100) * screenWidth; // 64vw转px
				// 第一张的左边界（居中基准）
				const maxLeft = screenWidth / 2 - itemWidth / 2;
				// 最后一张的右边界（居中基准）
				const maxRight = (screenWidth / 2 - itemWidth / 2) - (this.posterUrls.length - 1) * itemWidth;

				// 超出边界时增加阻力（弹性效果）
				if (this.translateX > maxLeft) {
					this.translateX = maxLeft + (this.translateX - maxLeft) * 0.2;
				} else if (this.translateX < maxRight) {
					this.translateX = maxRight + (this.translateX - maxRight) * 0.2;
				}
			},

			// 触摸/鼠标松开事件
			handleTouchEnd(e) {
				if (!this.isDragging) return;
				this.isDragging = false;
				this.transitionStyle = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)'; // 恢复动画

				// 计算拖拽距离，判断是否切换索引
				const endX = e.type === 'touchend' ? e.changedTouches[0].clientX : e.clientX;
				const diffX = endX - this.startX;
				const threshold = 50; // 切换阈值（px）

				// 确定目标索引
				let targetIndex = this.currentIndex;
				if (diffX > threshold) {
					// 向右滑：上一张
					targetIndex = Math.max(0, this.currentIndex - 1);
				} else if (diffX < -threshold) {
					// 向左滑：下一张
					targetIndex = Math.min(this.posterUrls.length - 1, this.currentIndex + 1);
				}

				// 松开后强制居中到目标索引
				this.centerToIndex(targetIndex);
			},

			// 预览海报
			onPreviewPoster(url) {
				const ImagePreview = require('vant').ImagePreview;
				ImagePreview([url]);
			},

			// 重新生成（跳回原页面）
			onRegenerate() {
				this.$router.push({
					name: 'AiPosterPage'
				});
			},

			// 下载当前海报
			async onDownload() {
				// if (String(this.vipType) !== '1') {
				// 	this.showVipTipModal = true;
				// 	return;
				// }
				const currentUrl = this.posterUrls[this.currentIndex];
				if (!currentUrl) {
					this.$toast && this.$toast("暂无海报可下载");
					return;
				}
				if(this.isMiniProgram){
					wx.miniProgram.navigateTo({
						//拼接url
						url:"/pages/webViewDownFile/index?filetype=img&fileUrl=" + encodeURIComponent(currentUrl),
					});
					// window.parent.postMessage({
					// 		type: "BACK_TO_DOMN",
					// 		filetype: 'img',
					// 		fileUrl: encodeURIComponent(currentUrl)
					// 	},
					// 	"*",
					// );
					return;
				}
				const link = document.createElement('a');
				link.href = currentUrl;
				link.download = `poster-${Date.now()}.png`;
				link.style.display = 'none';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				this.$toast && this.$toast("开始下载海报");
			},
		},
	};
</script>

<style scoped>
	.generated-poster-page {
		min-height: 100vh;
		min-height: 100dvh;
		background: #f5f6f8;
		display: flex;
		flex-direction: column;
	}

	/* 导航栏样式（完全复用） */
	.custom-nav-bar {
		width: 100vw;
		height: 11.7333vw;
		background-image: linear-gradient(90deg, #E7F2FA 0%, #DBE2F1 100%);
		box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
		position: relative;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
	}

	.back-btn {
		width: 6.4vw;
		height: 6.4vw;
		position: absolute;
		left: 2.6667vw;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.back-icon {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.nav-title {
		font-family: SourceHanSansSC-Medium;
		font-size: 4.8vw;
		color: #000000;
		letter-spacing: 0.1333vw;
		text-align: center;
		line-height: 11.7333vw;
		font-weight: 500;
	}

	/* 主体区域：仅承载圆点和按钮，轮播容器已固定 */
	.page-body {
		flex: 1;
		padding: 0;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-end;
		/* 按钮和圆点靠下 */
		padding-bottom: 20vw;
		/* 留出底部空间 */
	}

	/* 核心：轮播容器 - 强制固定在屏幕中央，溢出显示两侧图片 */
	.carousel-container {
		position: fixed;
		/* 固定定位，脱离文档流 */
		left: 50%;
		/* 左对齐屏幕中线 */
		top: 42%;
		/* 上对齐屏幕中线 */
		transform: translate(-50%, -50%);
		/* 反向平移，精准居中 */
		width: 100%;
		max-width: 100vw;
		/* 750px设计稿→100vw */
		height: 120vw;
		/* 中间图高度900px=120vw */
		max-height: 120vw;
		/* 和height保持一致，避免拉伸 */
		overflow: visible !important;
		/* 显示两侧溢出的图片 */
		touch-action: pan-y;
		/* 允许垂直滚动，阻止浏览器默认触摸行为 */
		z-index: 1;
		/* 确保在最上层 */
	}

	/* 轮播轨道：横向排列所有固定宽高容器（无gap） */
	.carousel-track {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		display: flex;
		align-items: center;
		will-change: transform;
		/* 优化动画性能 */
	}

	/* 轮播项外层容器：固定宽高，所有项尺寸一致 */
	.carousel-item-container {
		width: 64vw;
		/* 480px=64vw（750设计稿基准） */
		height: 120vw;
		/* 900px=120vw（750设计稿基准） */
		flex-shrink: 0;
		/* 不压缩，固定尺寸 */
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/* 图片容器：默认样式（两侧图，内部缩40px） */
	.carousel-item {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		/* 缩放0.9167倍 → 480*0.9167≈440px，留40px间距（20px*2） */
		transform: scale(0.8333);
		transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	/* 激活的图片容器（中间图）：无缩放，撑满外层容器 */
	.carousel-item.active {
		transform: scale(1);
		/* 480px宽，无间距 */
	}

	/* 海报卡片：适配固定容器 */
	.poster-card {
		width: 100%;
		height: 100%;
		background: #ffffff;
		border-radius: 3.2vw;
		/* 圆角24px=3.2vw */
		overflow: hidden;
		box-shadow: 0 0.5333vw 1.6vw rgba(0, 0, 0, 0.04);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/* 海报图片：撑满图片容器，保持原始比例 */
	.poster-img {
		/* width: 100%; */
		height: 100%;
		object-fit: contain;
		/* 关键：不拉伸，保留原图比例 */
		display: block;
	}

	/* 自定义指示器（圆点）：匹配设计稿 */
	.indicator-wrapper {
		display: flex;
		gap: 2.6667vw;
		position: fixed;
		left: 50%;
		top: calc(42% + 120vw/2 + 12vw);
		/* 核心：轮播图top + 轮播图高度/2 + 130px间距 */
		transform: translateX(-50%);
		/* 水平居中 */
		z-index: 10;
		/* 确保在轮播图上层 */
	}

	.indicator-dot {
		width: 2.6667vw;
		/* 圆点大小20px=2.6667vw */
		height: 2.6667vw;
		/* 圆点大小20px=2.6667vw */
		border-radius: 50%;
		background: #C2C2C2;
		/* 未选中色 */
		transition: background 0.2s ease;
		cursor: pointer;
	}

	.indicator-dot.active {
		background: #666666;
		/* 选中色 */
	}

	/* 底部操作按钮 */
	.preview-actions {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 3.2vw;
		/* 两按钮间距24px=3.2vw */
		position: fixed;
		left: 50%;
		/* 核心：轮播图top + 轮播图高度/2 + 130px + 98px 转vw */
		top: calc(42% + 60vw + 17.3333vw + 13.0667vw);
		transform: translateX(-50%);
		/* 水平居中 */
		z-index: 10;
		/* 确保在轮播图上层 */
	}

	/* 下载按钮样式（设计稿要求转vw） */
	.download-btn {
		width: 29.3333vw;
		/* 220px=29.3333vw */
		height: 8vw;
		/* 60px=8vw */
		background: #EBEBED;
		border-radius: 2.1333vw;
		/* 16px=2.1333vw */
		opacity: 0.8;
		font-family: SourceHanSansSC-Medium;
		font-size: 3.2vw;
		/* 24px=3.2vw */
		color: #666666;
		letter-spacing: 0;
		text-align: center;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/* 转发按钮样式（设计稿要求转vw） */
	.share-btn {
		width: 29.3333vw;
		/* 220px=29.3333vw */
		height: 8vw;
		/* 60px=8vw */
		background-image: linear-gradient(114deg, #2FFFB5 0%, #1E89FF 100%);
		border-radius: 2.1333vw;
		/* 16px=2.1333vw */
		font-family: SourceHanSansSC-Medium;
		font-size: 3.2vw;
		/* 24px=3.2vw */
		color: #FFFFFF;
		letter-spacing: 0;
		text-align: center;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.action-btn:active {
		opacity: 0.8;
	}
	
	/* 付费提示框遮罩层 */
	.vip-tip-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		height: 100dvh;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 99999;
	}
	
	/* 提示框主体（750px设计稿适配） */
	.vip-tip-modal {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 80vw;
		/* 600px/7.5 */
		height: 48vw;
		/* 360px/7.5 */
		background-color: #ffffff;
		border-radius: 3.2vw;
		/* 24px/7.5 */
		z-index: 100000;
		box-sizing: border-box;
		padding: 0;
	}
	
	/* 提示标题 */
	.vip-tip-title {
		margin-top: 5.333vw;
		/* 40px/7.5 */
		font-size: 4.267vw;
		/* 32px/7.5 */
		color: #1F2226;
		font-weight: 500;
		text-align: center;
	}
	
	/* 提示文案 */
	.vip-tip-content {
		margin-top: 4.267vw;
		/* 32px/7.5 */
		margin-left: 6.4vw;
		/* 48px/7.5 */
		margin-right: 6.4vw;
		/* 48px/7.5 */
		height: 9.6vw;
		/* 72px/7.5 - 固定高度 */
		font-size: 3.2vw;
		/* 24px/7.5 */
		color: #1F2226;
		font-weight: 400;
		word-break: break-word;
		overflow: hidden;
		box-sizing: border-box;
		/* 核心：确保height包含padding/margin，避免高度溢出 */
		/* 文字靠左（若要水平居中则改为center） */
		line-height: normal;
		/* 重置line-height，避免与flex冲突 */
		padding: 0;
		/* 确保无额外内边距干扰 */
		text-align: center;
	}
	
	/* 按钮组 */
	.vip-tip-btn-group {
		display: flex;
		justify-content: space-between;
		margin-top: 5.333vw;
		/* 40px/7.5 */
		margin-left: 6.4vw;
		/* 48px/7.5 */
		margin-right: 6.4vw;
		/* 48px/7.5 */
	}
	
	/* 按钮通用样式 */
	.vip-tip-btn {
		width: 32vw;
		/* 240px/7.5 */
		height: 11.867vw;
		/* 89px/7.5 */
		border-radius: 2.133vw;
		/* 16px/7.5 */
		border: none;
		font-size: 3.733vw;
		/* 28px/7.5 */
		font-weight: 500;
		cursor: pointer;
		line-height: 1;
	}
	
	/* 左侧返回按钮 */
	.cancel-btn {
		background-color: #F6F6F6;
		color: #1F2226;
	}
	
	/* 右侧去付费按钮（渐变背景） */
	.pay-btn {
		background: linear-gradient(121deg, #2FFFB5 0%, #1E89FF 100%);
		color: #FFFFFF;
	}
</style>